import styled from 'styled-components';

export default styled.div`
  background: #cb1b1b;
  width: 5rem;
  position: absolute;
  left: calc(50% - 5rem);
  text-align: center;
  color: #eaeaea;
  border-radius: 5px;
  padding: 2px 0;
  font-weight: 400;
  font-size: 1.2rem;
  font-family: 'Jost',Helvetica,Arial,sans-serif;
  line-height: 2rem;
`;
